import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import NoneData from "../common/NoneData";
export class CourseIntro extends Component {
  static propTypes = {
    course: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    const { intro } = this.props;
    return (
      <div className="course-course-intro">
        {
          intro && <div dangerouslySetInnerHTML={{ __html: intro }}>

          </div>
        }
        {
          !intro && <div className="noneData">
            <NoneData type={1} />
          </div>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    course: state.course,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseIntro);



// WEBPACK FOOTER //
// ./src/features/course/CourseIntro.js